<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
// Disable SSR for import page
definePageMeta({
  ssr: false
});

useHead({
  title: "Data Import - Komunite"
});

function handleUploadSuccess(response: any) {
  console.log("✅ Upload succeeded:", response);
}

function handleUploadFailure(error: any) {
  console.error("❌ Upload failed:", error);
}
</script>

<template>
  <UDashboardPanel id="data-import">
    <template #body>
      <div class="p-6 space-y-12">
        <!-- Data Import Section -->
        <AppSection title="CSV Data Import">
          <div class="max-w-3xl">
            <UCard>
              <ManagementImportCsvPanel
                upload-url="/api/management/data-import/import-csv"
                @upload-succeeded="handleUploadSuccess"
                @upload-failed="handleUploadFailure"
              />
            </UCard>

            <!-- CSV Format Info -->
            <UCard class="mt-6">
              <div class="text-xs text-muted space-y-3">
                <p class="font-medium text-sm">Expected CSV Format:</p>
                <ul class="list-disc list-inside space-y-1.5 ml-2">
                  <li>Column 0: Customer ID (membership_details.membershipkey)</li>
                  <li>Column 1: Phone Number (membership_details.phonenumber)</li>
                  <li>Column 2: First Name (membership_details.firstname)</li>
                  <li>Column 3: Last Name (membership_details.lastname)</li>
                  <li>Column 4: Staff Assigned (membership_details.employee)</li>
                  <li>Column 5: Staff Served (purchases.employee)</li>
                  <li>Column 6: Branch ID (purchases.branchid)</li>
                  <li>Column 7: Created At (purchases.createdat)</li>
                  <li>Column 9: Order Amount (purchases.sales)</li>
                </ul>
              </div>
            </UCard>
          </div>
        </AppSection>
      </div>
    </template>
  </UDashboardPanel>
</template>
